/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, forwardRef, useEffect } from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from "notistack";
import { snackAction } from '../../components/CustomSnakbar.jsx'
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
//import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { Button, TableContainer } from '@mui/material';
import { AccountStatusForm } from './AccountStatusForm';
import './AccountStatus.css';
import { useDispatch, useSelector } from 'react-redux';
import { getAccountData } from '../../Store/Ducks/duckSupplier.js';
import { setNumberFormat } from '../../Utils/setNumberFormat.js';
import { getPaymentDoc } from '../../Store/Ducks/duckVoucherDocument.js';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import DialogContainerForRejectedReason from './DialogContainerForRejectedReason.jsx';


const ExportButton = forwardRef((props, ref) => {

    return (
        <Button
            variant="outlined"
            color="primary"
            size="small"
            style={{ margin: '0px -8px 0px -17px' }}
            {...props}
            ref={ref}
        >
            Exportar
        </Button>
    )
});

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    //Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Export: ExportButton,
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

export const AccountStatusTable = ({
    email,
    //accountData,
    stateFilter,
    setStateFilter,
    invoiceFilter,
    setInvoiceFilter,
    selectedCuit,
    setSelectedCuit
}) => {

    const dispatch = useDispatch()

    const accountData = useSelector(store => store.supplier?.data?.accountData)

    const [supplierNifError, setSupplierNifError] = useState(false);
    const [showModalRejectedReason, setShowModalRejectedReason] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState({});
    const [accountDataValues, setAccountDataValues] = useState()

    const { enqueueSnackbar } = useSnackbar();

    const history = useHistory();

    useEffect(() => {
        //if (selectedCuit !== null)
        selectedCuit && dispatch(getAccountData(email, selectedCuit))
    }, [selectedCuit])

    useEffect(() => {
        if (accountData !== undefined) setAccountDataValues(accountData)
    }, [accountData])

    const filteredData = accountDataValues?.filter(
        (item) =>
            item.statuS_FACTURA_GROUP_DESC?.includes(stateFilter) &&
            item.reference?.toLowerCase().includes(invoiceFilter.toLowerCase())
    );

    const statusList = accountDataValues ? [...new Set(accountDataValues.map(item => item.statuS_FACTURA_GROUP_DESC))] : [];

    const handleRowClick = (rowData) => {
        if (selectedCuit === null || selectedCuit === '') {
            enqueueSnackbar(`Para crear una Consulta, debe completar el valor del NIF`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
            setSupplierNifError(true);
        } else {
            const state = {
                companyFromAccount: rowData.companY_CODE || '',
                nifFromAccount: selectedCuit,
                invoiceFromAccount: rowData.reference || '',
                categoryFromAccount: 7 || null,
                origin: 'fromAccount'
                //subCategoryFromAccount: 7
            };
            setSupplierNifError(false);
            history.push('/NuevaConsulta', state);
        }
    }

    const handleProofPayment = (rowData) => {
        dispatch(getPaymentDoc(
            rowData.companY_CODE, rowData.compenS_DOC,rowData.vendoR_NUM, rowData.compensatioN_DATE_ID
        ))
        .then(res => {
            window.open(res?.payload?.request?.responseURL);
        })
        .catch(error => {
            //console.log(error);
            enqueueSnackbar("Comprobante de pago aún no disponible", {
                variant: "warning",
                action: snackAction,
                autoHideDuration: 2000,
            });
        });
    };

    const handleModalRejectedReason = (rowData) => {
        setSelectedRowData(rowData);
        setShowModalRejectedReason(true);
    }

    const closeModalRejectedReason = () => setShowModalRejectedReason(false);
    

    const parseDate = (date) => {
        const separators = ["-", "/", "*"];

        for(const separator of separators){
            const parts = date.split(separator);
            if(parts.length === 3){
                const day = parseInt(parts[0], 10);
                const month = parseInt(parts[1], 10) - 1;
                const year = parseInt(parts[2], 10);
                return new Date(year, month, day);
            }
        }

        return null;
    }

    const dateSort = (a, b) => {
        const dateA = parseDate(a);
        const dateB = parseDate(b);

        if(dateA !== null && dateB != null){
            return dateA - dateB;
        }
        else{
            return 0;
        }
    }

    const defaultHeaderStyles = {
        backgroundColor: '#002B5C',
        whiteSpace: 'normal', 
        fontSize: "14px", 
        color: '#fff',
        lineHeight: '1.2',
        padding: '10px 2px 10px 12px'
    }

    return (
        <>
            <TableContainer className="custom-table">

                <MaterialTable
                    icons={tableIcons}
                    options={{
                        search: false,
                        exportButton: {
                            csv: true,
                            pdf: false,
                        },
                        exportAllData: true,
                        // responsive: 'standard',
                    }}
                    columns={[
                        {
                            title: '#Factura', field: 'reference', headerStyle: defaultHeaderStyles
                        },
                        {
                            title: 'Fecha Factura', field: 'datE_DOCUMENT', filtering: false, headerStyle: defaultHeaderStyles,
                            customSort: (a, b) => dateSort(a.datE_DOCUMENT, b.datE_DOCUMENT)
                        },
                        {
                            title: 'Fecha Recepción', field: 'f_Recepcion', filtering: false, headerStyle: defaultHeaderStyles,
                            customSort: (a, b) => dateSort(a.f_Recepcion, b.f_Recepcion)
                        },
                        {
                            title: 'Fecha Pago', field: 'compensatioN_DATE', filtering: false, headerStyle: defaultHeaderStyles,
                            render: (rowData) => (rowData.statuS_FACTURA_GROUP_DESC === "Paid" ? rowData.compensatioN_DATE : "")                                     
                        },                        
                        {
                            title: 'Fuente', field: 'sourcE_INVOICES_DESC', filtering: false, headerStyle: defaultHeaderStyles
                        },
                        {
                            title: 'Compañía', field: 'companY_DESC', filtering: false, headerStyle: defaultHeaderStyles, cellStyle: {
                                whiteSpace: 'nowrap'
                               },
                        },

                        {
                            title: 'Importe', field: 'amount', filtering: false, headerStyle: defaultHeaderStyles,
                            render: (rowData) => setNumberFormat(rowData.amount)

                        },
                        {
                            title: 'Moneda', field: 'currencY_DESC', filtering: false, headerStyle: defaultHeaderStyles
                        },
                    
                        {
                            title: 'Estado', field: 'statuS_FACTURA_GROUP_DESC', headerStyle: defaultHeaderStyles,
                            render: (rowData) => {
                                if(rowData.statuS_FACTURA_GROUP_DESC === "Rejected"){
                                    return (
                                        <Tooltip title={"Click para ver Motivos de Rechazo"} arrow TransitionComponent={Zoom}>
                                            <div className='block-rejected' onClick={() => handleModalRejectedReason(rowData)} style={{ display:"flex", alignItems:"center", textTransform:'none' }}>
                                                <span className='link-rejected'>Rejected</span>
                                                <InfoOutlinedIcon fontSize="small" color="primary" style={{margin:"0px 0px 1.2px 4.2px", fontSize:"1rem", color:"inherit"}}/>
                                            </div>
                                        </Tooltip>
                                    )
                                }
                                else{
                                    return rowData.statuS_FACTURA_GROUP_DESC;
                                }    
                            }
                        },
                        {
                            title: 'Adjunto', field: 'attachment', filtering: false, headerStyle: defaultHeaderStyles, 
                            export: false, render: (rowData) => (
                                <Button variant="outlined" size="small" onClick={() => window.open(rowData.linK_LEGAJO, "_blank")}>Descarga</Button>
                            )
                        },
                        {
                            title: 'Consulta', field: 'createQuery', filtering: false, headerStyle: defaultHeaderStyles, 
                            export: false, render: (rowData) => (
                                <Button variant="contained" size="small" onClick={() => handleRowClick(rowData)}>
                                    Crear
                                </Button>
                            )
                        },
                        {
                            title: 'Comprobante Pago', field: 'proofOfPayment', filtering: false, headerStyle: defaultHeaderStyles, 
                            export: false, render: (rowData) => {
                                if(rowData.statuS_FACTURA_GROUP_DESC === "Paid")
                                    return <Button variant="outlined" size="small" onClick={() => handleProofPayment(rowData)}>Descarga</Button>
                            }
                        },
                    ]}
                    data={filteredData}
                    title={false}
                    components={{
                        Toolbar: (props) => (
                            <div>
                                <div style={{ padding: '0px 10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <AccountStatusForm
                                        //{...props}
                                        email={email}
                                        stateFilter={stateFilter}
                                        invoiceFilter={invoiceFilter}
                                        setStateFilter={setStateFilter}
                                        setInvoiceFilter={setInvoiceFilter}
                                        selectedCuit={selectedCuit}
                                        setSelectedCuit={setSelectedCuit}
                                        supplierNifError={supplierNifError}
                                        setSupplierNifError={setSupplierNifError}
                                        statusList={statusList}
                                    />
                                    <MTableToolbar {...props} />
                                </div>
                            </div>
                        ),
                    }}
                    buttonStyle={{
                        boxShadow: 'none',
                    }}
                />

            </TableContainer>
            {
                showModalRejectedReason && 
                <DialogContainerForRejectedReason
                    showDialog={showModalRejectedReason}
                    closeDialog={closeModalRejectedReason}
                    selectedRowData={selectedRowData}
                />
            }
        </>
    )
}
